import { makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import React, { FC } from "react"
import { useRecoilState } from "recoil"
import { useNavigation } from "../../hooks/useNavigation"
import { forgotPasswordEmailState } from "../../utils/store"
import { colors } from "../../utils/theme"
import { PrimaryButton } from "../atoms/button/Button"
import Logo from "../atoms/Logo"
import { TitledCard } from "../molecules/titledCard/TitledCard"
import { BaseTemplate } from "../templates/BaseTemplate"

const useStyles = makeStyles((theme) => ({
  logo: {
    position: "absolute",
    top: theme.spacing(6),
    left: theme.spacing(6),
  },
  button: {
    width: "100%",
  },
  marginBottom32: {
    marginBottom: theme.spacing(4),
  },
  denim: {
    color: colors.neutral.denim,
  },
}))

const ForgotPasswordSuccess: FC = () => {
  const classes = useStyles()
  const { toLogin } = useNavigation()
  const [email, setEmail] = useRecoilState(forgotPasswordEmailState)

  return (
    <BaseTemplate>
      <Logo className={classes.logo} />
      <TitledCard title="Forgot Password">
        <Typography
          variant="body1"
          className={clsx(classes.marginBottom32, classes.denim)}
        >
          {`An email has been sent to ${email} with further instructions.`}
        </Typography>
        <PrimaryButton
          className={classes.button}
          onClick={() => {
            setEmail(undefined)
            toLogin()
          }}
        >
          Back to Log In
        </PrimaryButton>
      </TitledCard>
    </BaseTemplate>
  )
}

export default ForgotPasswordSuccess
